export type IModulesState = {
    id: string;
    name: string;
}

export enum IModuleActionTypes {
    FETCH_MODULE_LIST_REQUEST = 'FETCH_MODULE_LIST_REQUEST',
    FETCH_MODULE_LIST_SUCCESS = 'FETCH_MODULE_LIST_SUCCESS',
    FETCH_MODULE_LIST_FAILURE = 'FETCH_MODULE_LIST_FAILURE',

}

export type IMODULEActionCreator = {
    type: string;
    payload: IModulesState;
  };
